import { CSSProperties, useEffect } from 'react';
import { useParams } from 'react-router';
import { useAnnotateStudyFormHook, useStudyWithUserCheck } from '@vivli/features/studies/infrastructure/hook';
import { LoadIndicatorCenteredView } from '@vivli/shared/views';
import { StudyContext } from '@vivli/features/studies/infrastructure/context';
import { AnnotateStudyFormComponent } from '@vivli/features/studies/components';
import { StudyContextWrapper } from '@vivli/features/studies/infrastructure/wrappers';
import { AnnotateStudyHeaderComponent } from '../../../../components/src/lib/annotate-study/annotate-study-header.component';
import { FormProvider } from 'react-hook-form';

const containerStyle: CSSProperties = {
    backgroundColor: 'rgb(233, 234, 239)',
    overflow: 'hidden',
    transform: 'translate3d(0,0,0)', // force chrome to use GPU for rendering - fixes UI 'whiteout' glitch related to scrollbars (I think),
    display: 'flex',
    flexDirection: 'column',
    minWidth: '100%',
    flexGrow: 2,
    height: '100%'
};

export const AnnotateStudyFeature = () => {
    const { studyId } = useParams();
    const { study, studyUsedIn, studyIpdDataPackageSubmitted } = useStudyWithUserCheck(studyId);
    const formApi = useAnnotateStudyFormHook(study);

    useEffect(() => {
        // force initial validation
        formApi.trigger();
    }, []);

    useEffect(() => {
        if (!study) return;

        formApi.reset(study, { keepErrors: true, keepIsValid: false, keepDirty: false });
    }, [study]);

    return (
        <div style={containerStyle}>
            <FormProvider {...formApi}>
                <StudyContextWrapper study={study} usedIn={studyUsedIn} studyIpdPackageSubmitted={studyIpdDataPackageSubmitted}>
                    <StudyContext.Consumer>
                        {({ study }) => {
                            if (!study) {
                                return <LoadIndicatorCenteredView />;
                            }
                            return <AnnotateStudyFormComponent />;
                        }}
                    </StudyContext.Consumer>
                </StudyContextWrapper>
            </FormProvider>
        </div>
    );
};
